var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "NumberInput form-group",
    class: {
      row: _vm.inline
    }
  }, [_c('label', {
    staticClass: "font-weight-bold",
    class: {
      'col col-form-label': _vm.inline
    },
    attrs: {
      "data-qa": _vm.qa + '.label',
      "for": _vm.id
    }
  }, [_vm._t("default")], 2), _c('div', {
    class: {
      'col-5 col-md-4': _vm.inline
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row flex-nowrap align-items-center"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.canSubtract,
      "type": "button"
    },
    on: {
      "click": _vm.subtract
    }
  }, [_vm._v(" - ")])]), _c('div', {
    staticClass: "\n        flex-fill\n        number-input-text\n        overflow-hidden\n        m-2\n        text-center text-primary\n        font-weight-bolder\n      "
  }, [_vm._v(" " + _vm._s(_vm.value) + " ")]), _c('div', [_c('button', {
    staticClass: "NumberInput-btn btn btn-primary",
    attrs: {
      "disabled": !_vm.canAdd,
      "type": "button"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(" + ")])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }